import request from '@/router/axios'

export function getAllProvince(query) {
  return request({
    url: '/city/getAllProvince',
    method: 'post',
    params: query
  })
}

export function getCityForProvinceCode(query) {
  return request({
    url: '/city/getCityForProvinceCode',
    method: 'post',
    params: query
  })
}

export function predictPrice(query) {
  return request({
    url: '/predictPrice/',
    method: 'post',
    params: query
  })
}

export function updatePriceForIds(query) {
  return request({
    url: '/predictPrice/updatePriceForIds',
    method: 'post',
    params: query
  })
}

export function getWorkerPriceMappings(query) {
  return request({
    url: '/predictPrice/getWorkerPriceMappings',
    method: 'post',
    params: query
  })
}
